export default __webpack_public_path__ + "static/media/no-image-2.1e05edcf.jpg";